import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HTTP_METHODS, invokeApi, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import FormGenerator from "../../core/form-generator";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  FOC_FORM_COFIG1,
  FOC_FORM_COFIG3,
  FOC_FORM_CONFIG4,
  FOC_FORM_CONFIG_ADDRESS,
  SERVICE_TABLE_HEADERS,
} from "./helper";
import SiTextField from "../../core/si-textfield";
import CustomTable from "../../core/custom-table";
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import SiFileUpload from "../../core/file-uploader";
import CustomButtonComponent from "../../core/custom-button";
import { formatDate, handleFormValidation } from "../../utils";
import PreviewFormGenerator from "../../core/preview-form-generator";
import FormContainer from "../../core/form-container";
import { DATE_FORMATS } from "../../utils/constants";
const FocForm = () => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [freeServiceCount, setFreeServiceCount] = useState(
    Array.from({ length: 7 }, (_, index) => index + 1)
  );
  const [isPreviewForm, setIsPreviewForm] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [recommandedParts, setRecommandedParts] = useState([
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
  ]);
  const [focReleaseRequest, setFocReleaseRequest] = useState([
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
  ]);
  const [files, setFiles] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [rejectionComment, setRejectionComment] = useState("");
  const { ticketId } = useParams();
  const navigate = useNavigate();
  const loadData = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STAGE_VIEW}/${ticketId}`,
      null
    )
      .then((response) => {
        if (response.code === 404) {
          toast.error("Invalid ticket");
          return;
        } else {
          if (response.ticket.foc) {
            const { foc } = response.ticket;
            setFormData((prevVal) => ({
              ...prevVal,
              ...foc,
              line1: foc?.address?.line1,
              line2: foc?.address?.line2,
              line3: foc?.address?.line3,
              city: foc?.address?.city,
              state: { label: foc?.address?.state, value: foc?.address?.state },

              pinCode: foc?.address?.pinCode,
              warrantyClaimNo: foc?.focReleaseRequest?.warrantyClaimNo,
              failureDate:
                foc?.failureDate &&
                formatDate(foc?.failureDate, DATE_FORMATS["DD-MM-YYYY"]),
              // date:
              //   foc?.date && formatDate(foc?.date, DATE_FORMATS["DD-MM-YYYY"]),
              installationDate:
                foc?.installationDate &&
                formatDate(foc?.installationDate, DATE_FORMATS["DD-MM-YYYY"]),
              oemName: response?.complaintForm?.oemName,
              engineSerialNumber: response?.complaintForm?.engineSerialNumber,
              engineModel: response?.ticket?.engineModal,
            }));
            setRejectionComment(foc?.rejectionComment || "");
            setSelectedService(foc?.freeServicesCarriedOut);
            setFiles(foc?.attachments);
            setIsUpdate(true);
            setRecommandedParts(foc?.partsReplacement);
            foc?.focReleaseRequest?.partsData.length > 0 &&
              setFocReleaseRequest(foc?.focReleaseRequest?.partsData);
          } else {
            setFormData({
              ...formData,
              oemName: response?.complaintForm?.oemName,
              engineSerialNumber: response?.complaintForm?.engineSerialNumber,
              engineModel: response?.ticket?.engineModal,
            });
          }
        }
      })
      .catch((err) => console.error(err));
  };

  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  useEffect(() => {
    loadData();
  }, []);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setFormData((prevFormData) => ({
      ...prevFormData,
      freeServicesCarriedOut: service,
    }));
  };

  const recommandedPartsHandler = (data, label, value) => {
    setRecommandedParts((prevRows) =>
      prevRows.map((row, index) =>
        index === data.index ? { ...row, [label]: value } : row
      )
    );
  };
  const focReleaseRequestHandler = (data, label, value) => {
    setFocReleaseRequest((prevRows) =>
      prevRows.map((row, index) =>
        index === data.index ? { ...row, [label]: value } : row
      )
    );
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };
  const cleanedRecommandedParts = () =>
    recommandedParts.filter(
      (part) => part.partNumber && part.description && part.qty
    );

  const cleanedFocReleaseRequest = () =>
    focReleaseRequest.filter(
      (part) => part.partNumber && part.description && part.qty
    );
  const submitHandler = () => {
    const payload = {
      ...formData,

      address: {
        line1: formData.line1,
        line2: formData.line2,
        line3: formData.line3,
        city: formData.city,
        state: formData.state?.value,
        pinCode: formData.pinCode,
      },

      partsReplacement: cleanedRecommandedParts(),
      focReleaseRequest: {
        warrantyClaimNo: formData.warrantyClaimNo,
        partsData: cleanedFocReleaseRequest(),
      },

      attachments: files.map((file) => file.url || file),
    };
    delete payload.line1;
    delete payload.line2;
    delete payload.line3;
    delete payload.city;
    delete payload.state;
    delete payload.pinCode;
    delete payload.warrantyClaimNo;
    delete payload.oemName;

    if (isUpdate) {
      delete payload?.partsReplacement;
      delete payload?.focReleaseRequest;
      delete payload?.focStatus;
      delete payload?.oem;
      delete payload?.ticket;
      delete payload?.createdAt;
      delete payload?.updatedAt;
      delete payload?.id;
      delete payload?.rejectionComment;
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.CREATE_FOC}/${ticketId}`,
        payload
      )
        .then((response) => {
          if (response.message) {
            toast.error(`Failed to update FOC, ${response.message}`);
            setIsPreviewForm(false);
          } else {
            toast.success(`FOC Form Updated successfully`);
            navigate(-1);
          }
        })
        .catch((err) => console.error(err));
    } else {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CREATE_FOC}/${ticketId}`,
        payload
      )
        .then((response) => {
          if (response.message) {
            toast.error(`Failed to submit FOC, ${response.message}`);
            setIsPreviewForm(false);
          } else {
            toast.success(`FOC Form Submitted successfully`);
            navigate(-1);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const previewFormHandler = () => {
    const isValid = handleFormValidation(
      [
        ...FOC_FORM_COFIG1,
        ...FOC_FORM_CONFIG_ADDRESS,
        ...FOC_FORM_COFIG3,
        ...FOC_FORM_CONFIG4(),
      ],
      setErrors,
      formData
    );

    if (isValid) {
      setIsPreviewForm(true);
    } else {
      toast.error("Please correct the errors in the form.");
    }
  };

  return (
    <div className="page-body">
      <div className="view-detailed-ticket">
        <ArrowBackIcon
          sx={{ cursor: "pointer", marginRight: "20px" }}
          onClick={() => {
            navigate(-1);
          }}
        />
        <div>
          <p className="tab-name">Service Support</p>
          <p className="section-name">FOC Release Request Form</p>
        </div>
      </div>
      <FormContainer className="mt-0">
        <div>
          {!isPreviewForm ? (
            <div>
              {rejectionComment && (
                <Box
                  sx={{
                    width: "95%",
                    mt: 2,
                    p: 2,
                    border: "1px solid red",
                    borderRadius: "15px",
                    backgroundColor: "#fff0f0",
                    marginBottom: "20px",
                  }}
                >
                  <Typography variant="h6" sx={{ color: "red" }}>
                    Rejection Reason
                  </Typography>
                  <Typography>{rejectionComment}</Typography>
                </Box>
              )}
              <FormGenerator
                config={FOC_FORM_COFIG1}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <p>Address</p>
              <FormGenerator
                config={FOC_FORM_CONFIG_ADDRESS}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <FormGenerator
                config={FOC_FORM_COFIG3}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <div>
                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "80px" }}>
                    <p>Free Service Carried Out</p>
                    <div style={{ display: "flex" }}>
                      {freeServiceCount?.map((ele) => (
                        <div
                          key={ele}
                          className="free-service-count"
                          onClick={() => handleServiceClick(ele)}
                          style={{
                            backgroundColor:
                              selectedService === ele && "#001a53",
                            color: selectedService === ele && "white",
                            cursor: "pointer",
                          }}
                        >
                          {ele}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <p>Part Claim No. if any</p>
                    <SiTextField
                      name="pastClaimIfAny"
                      type="number"
                      onChange={(e) =>
                        setFormData((prevVal) => ({
                          ...prevVal,
                          pastClaimIfAny: e.target.value,
                        }))
                      }
                      placeholder="Part Claim No."
                      sx={{ width: "330px" }}
                      value={formData?.pastClaimIfAny}
                    />
                  </div>
                </div>
                <div>
                  <p>Parts Recommended for Replacement</p>
                  <Box sx={{ width: "95%" }}>
                    <CustomTable
                      header={SERVICE_TABLE_HEADERS}
                      data={recommandedParts.map((row, index) => ({
                        ...row,
                        index,
                      }))}
                      onClick={recommandedPartsHandler}
                    />
                  </Box>
                </div>
              </div>
              <FormGenerator
                config={FOC_FORM_CONFIG4()}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <div>
                <p>FOC Release Request</p>
                <Box sx={{ width: "95%" }}>
                  <CustomTable
                    header={SERVICE_TABLE_HEADERS}
                    data={focReleaseRequest.map((row, index) => ({
                      ...row,
                      index,
                    }))}
                    onClick={focReleaseRequestHandler}
                  />
                </Box>
              </div>
              <div>
                <Grid container spacing={5} sx={{ mt: 1 }}>
                  <Grid item md={5.7}>
                    <Box
                      sx={{
                        backgroundColor: "#F4F5F9",
                        borderRadius: "4px",
                        border: "1px solid #DBDCDE",
                        height: "130px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {formData?.oemSign ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                          }}
                        >
                          <img
                            src={formData.oemSign}
                            alt="signature"
                            width="70%"
                            height="60%"
                            style={{ maxWWidth: "800px", maxHeight: "150px" }}
                          />
                          <IconButton
                            onClick={() =>
                              setFormData((prevVal) => ({
                                ...prevVal,
                                oemSign: null,
                              }))
                            }
                            sx={{ p: 0 }}
                          >
                            <CancelOutlinedIcon color="error" />
                          </IconButton>
                        </div>
                      ) : (
                        <SiFileUpload
                          id={null}
                          title="Dealer/ OEM Seal & Signature"
                          callBack={(newFile) =>
                            setFormData((prevVal) => ({
                              ...prevVal,
                              oemSign: newFile.url,
                            }))
                          }
                        />
                      )}
                    </Box>
                    {/* <SiTextField
                      name="oemSign"
                      type="text"
                      onChange={(e) =>
                        setFormData((prevVal) => ({
                          ...prevVal,
                          oemSign: e.target.value,
                        }))
                      }
                      value={formData.oemSign}
                      multiline
                      rows={5}
                    /> */}
                    <p style={{ textAlign: "center" }}>
                      Dealer/ OEM Seal & Signature
                    </p>
                  </Grid>
                  <Grid item md={5.7}>
                    <SiTextField
                      name="oemServiceComment"
                      type="text"
                      onChange={(e) =>
                        setFormData((prevVal) => ({
                          ...prevVal,
                          oemServiceComment: e.target.value,
                        }))
                      }
                      multiline
                      rows={5}
                      value={formData.oemServiceComment || ""}
                    />
                    <p style={{ textAlign: "center" }}>
                      OEM Service H.O comments
                    </p>
                  </Grid>
                </Grid>
              </div>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <SiFileUpload id={null} callBack={callBack} />
                <CustomButtonComponent
                  variant="contained"
                  sx={{ width: "150px", ml: 3 }}
                  size="small"
                  onClick={previewFormHandler}
                >
                  Preview
                </CustomButtonComponent>
              </Box>
            </div>
          ) : (
            <div>
              <Box sx={{ display: "flex" }}>
                <ArrowBackIcon
                  sx={{ mr: 1, cursor: "pointer" }}
                  onClick={() => setIsPreviewForm(false)}
                />
                <p className="form-header">Preview FOC Release Request Form</p>
              </Box>
              <div>
                <PreviewFormGenerator
                  formConfig={FOC_FORM_COFIG1}
                  formValues={formData}
                />
                <p>Address</p>
                <PreviewFormGenerator
                  formConfig={FOC_FORM_CONFIG_ADDRESS}
                  formValues={formData}
                />
                <PreviewFormGenerator
                  formConfig={FOC_FORM_COFIG3}
                  formValues={formData}
                />
                <div>
                  <Grid container>
                    <Grid md={4} sx={{ pr: 3 }}>
                      <p>Free Service Carried Out</p>

                      <SiTextField
                        disabled={true}
                        value={formData.freeServicesCarriedOut}
                      />
                    </Grid>
                    <Grid md={4} sx={{ pr: 3 }}>
                      <p>Part Claim No. if any</p>
                      <SiTextField
                        name="pastClaimIfAny"
                        disabled={true}
                        value={formData?.pastClaimIfAny || ""}
                        placeholder="Part Claim No."
                      />
                    </Grid>
                  </Grid>

                  <div>
                    <p>Parts Recommended for Replacement</p>
                    <div className="ph-table">
                      {cleanedRecommandedParts().length > 0 && (
                        <div className="foc-header pht-header table-header-bg">
                          <span>Part No.</span>
                          <span>Description</span>
                          <span>Qty</span>
                        </div>
                      )}
                      {cleanedRecommandedParts().map((item, index) => {
                        return (
                          <div className="foc-header pht-header">
                            <span>{item.partNumber}</span>
                            <span>{item.description}</span>
                            <span>{item.qty}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <PreviewFormGenerator
                  formConfig={FOC_FORM_CONFIG4()}
                  formValues={formData}
                />
                <div>
                  <p>FOC Release Request</p>
                  <div className="ph-table">
                    <div className="foc-header pht-header table-header-bg">
                      <span>Part No.</span>
                      <span>Description</span>
                      <span>Qty</span>
                    </div>

                    {cleanedFocReleaseRequest().map((item, index) => {
                      return (
                        <div className="foc-header pht-header">
                          <span>{item.partNumber}</span>
                          <span>{item.description}</span>
                          <span>{item.qty}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <Grid container spacing={5} sx={{ mt: 1 }}>
                    <Grid item md={5.7}>
                      <Box
                        sx={{
                          backgroundColor: "#F4F5F9",
                          borderRadius: "4px",
                          border: "1px solid #DBDCDE",
                          height: "130px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {formData?.oemSign && (
                          <img
                            src={formData.oemSign}
                            alt="signature"
                            width="70%"
                            height="60%"
                          />
                        )}
                      </Box>
                      <p style={{ textAlign: "center" }}>
                        Dealer/ OEM Seal & Signature
                      </p>
                    </Grid>
                    <Grid item md={5.7}>
                      <SiTextField
                        name="oemServiceComment"
                        type="text"
                        onChange={(e) =>
                          setFormData((prevVal) => ({
                            ...prevVal,
                            oemServiceComment: e.target.value,
                          }))
                        }
                        multiline
                        value={formData.oemServiceComment}
                        rows={5}
                        disabled={true}
                      />
                      <p style={{ textAlign: "center" }}>
                        OEM Service H.O comments
                      </p>
                    </Grid>
                  </Grid>
                </div>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CustomButtonComponent
                    variant="contained"
                    sx={{ width: "150px", ml: 3 }}
                    size="small"
                    onClick={submitHandler}
                  >
                    Submit
                  </CustomButtonComponent>
                </Box>
              </div>
            </div>
          )}

          {files.map((r, index) => {
            return (
              <div key={r.blobName + index}>
                {r.blobName ? (
                  <span>{r.blobName}</span>
                ) : (
                  <a href={r} target="_blank">{`Attachment ${index + 1}`}</a>
                )}

                <IconButton onClick={() => onDelete(index)} sx={{ p: 0 }}>
                  <CancelOutlinedIcon />
                </IconButton>
              </div>
            );
          })}
        </div>
      </FormContainer>
    </div>
  );
};

export default FocForm;
